/* Oplayce — recalcule le bloc « Payez en plusieurs fois » quand l'internaute change de variante
   (couleur, capacité, taille…). Dawn ne rafraîchit lui-même que ses propres blocs (prix, SKU, stock) ;
   ce script raccroche notre bloc mensualités au même mécanisme, sans appel réseau supplémentaire :
   la fiche déjà reçue par Dawn (product-info.js) contient la version recalculée pour la nouvelle variante. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var sectionId = event && event.data && event.data.sectionId;
    var html = event && event.data && event.data.html;
    if (!sectionId || !html) return;
    var id = 'oplayce-mensualites-' + sectionId;
    var source = html.getElementById(id);
    var destination = document.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
  });
})();
